export default "__VITE_ASSET__299f73ee__"